import "./style.css";

export default function Benefits(){
  return(
    <div className="benefits">
      <div className="benefits-container">
        <div className="benefits-title">
          <h2>
            O que você vai conquistar com a<br/>
            <span>Mentoria  Beleza Lucrativa</span>
          </h2>
        </div>
        <div className="benefits-list">
          <ul>
            <li>✅ Como lotar sua agenda usando o Instagram de forma estratégica</li>
            <li>✅ Como precificar corretamente e parar de trabalhar por pouco</li>
            <li>✅ Como se posicionar como referência na sua cidade</li>
            <li>✅ Como atrair clientes certos e premium</li>
            <li>✅ Como organizar sua rotina e ganhar tempo</li>
            <li>✅ Como vender mais sem depender de indicações</li>
          </ul>
          <p>Bônus exclusivos:</p>
          <ul>
            <li>🎁 Módulo completo de Tráfego Pago para atrair mais clientes</li>
            <li>🎁 Site básico para o seu negócio</li>
          </ul>
        </div>
      </div>
    </div>
  );
};